import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Button } from "@/DesignSystem";

import styles from "./AIScribe.module.scss";

interface AIScribeCloseWarningPopupProps {
    onClose: () => void;
    onCloseAIAssistant: () => void;
    onKeepOpen: () => void;
}

function AIScribeCloseWarningPopup(props: Readonly<AIScribeCloseWarningPopupProps>): JSX.Element {
    const { getText } = useTranslation();

    function renderFooter(): JSX.Element {
        return (
            <div className="flex-container flex-end">
                <ButtonGroup>
                    <Button
                        variant="brand"
                        label={getText("AIScribe_ClosePopup_KeepOpen")}
                        onClick={() => props.onKeepOpen?.()}
                        size="lg"
                        id="ai-scribe-close-popup-keep-open"
                        dataCy="ai-scribe-close-popup-keep-open"
                    />
                    <Button
                        category="secondary"
                        variant="neutral"
                        label={getText("AIScribe_ClosePopup_Close")}
                        onClick={() => props.onCloseAIAssistant?.()}
                        size="lg"
                        id="ai-scribe-close-popup-close"
                        dataCy="ai-scribe-close-popup-close"
                    />
                </ButtonGroup>
            </div>
        );
    }

    return (
        <Modal
            fixedOverlayPosition
            showOverlay
            roundTopCorner
            showX
            draggable
            disableOverlayClose
            width={465}
            title={getText("AIScribe_ClosePopup_Close")}
            onClose={() => props.onClose?.()}
            id="ai-scribe-close-popup"
            dataCy="ai-scribe-close-popup"
            footer={renderFooter()}
            cssClass={styles.closeWarningPopup}
        >
            <div className={styles.content}>
                <p>{getText("AIScribe_ClosePopup_Message1")}</p>
                <p>{getText("AIScribe_ClosePopup_Message2")}</p>
                <p>{getText("AIScribe_ClosePopup_Message3")}</p>
            </div>
        </Modal>
    );
}

export { AIScribeCloseWarningPopup };
